// extracted by mini-css-extract-plugin
export default {"checkmark-list__item":"_1otNyyiys3aEyCnsAMF8c3","checkmark-list__icon":"_2aV9tOpxd8scCqiVMWzYh6","checkmark-list__content":"_3TsU1vFq9gIxvZaHXR_-3N"};